/**
 *  @class
 *  @function Pagination
 */

if (!customElements.get('pagination')) {
  class Pagination extends HTMLElement {
    constructor() {
      super();
      const id = this.dataset.section;
      this.button = this.querySelector('.load-more');
      this.grid = document.querySelector('[data-id=' + id + ']');
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
      this.i = 2;
    }
    connectedCallback() {
      if (this.classList.contains('pagination-type--loadmore')) {
        this.loadMore();
      }
      if (this.classList.contains('pagination-type--infinite')) {
        this.infinite();
      }
    }
    addUrlParam(search, key) {
      var newParam = key + '=' + this.i,
        params = '?' + newParam;

      // If the "search" string exists, then build params from it
      if (search) {
        // Try to replace an existance instance
        params = search.replace(new RegExp('([?&])' + key + '[^&]*'), '$1' + newParam);

        // If nothing was replaced, then add the new param to the end
        if (params === search) {
          params += '&' + newParam;
        }
      }

      return params;
    }
    loadMore() {
      let base = this;
      this.button.addEventListener('click', function () {
        base.loadProducts();
        this.blur();
        return false;
      });
    }
    infinite() {
      let base = this;
      base.observer = new IntersectionObserver(function (entries) {
        if (entries[0].intersectionRatio === 1) {
          base.loadProducts();
        }
      }, {
        threshold: [0, 1]
      });
      base.observer.observe(base);
    }
    loadProducts() {
      let base = this,
      url = document.location.pathname + base.addUrlParam(document.location.search, 'page');
    
      if (base.getAttribute('loading')) return;
      base.setAttribute('loading', true);
    
      fetch(url)
        .then(response => response.text())
        .then((responseText) => {
          const parsedHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const grid_to_replace = parsedHTML.getElementById('product-grid');
    
          // 🛑 If there's no product-grid or only promotion blocks
          const isPromoOnly = window.isCollectionPage
            ? !grid_to_replace.querySelector('.column:not(.promotion-column)')
            : !grid_to_replace.querySelector('.column'); // search page fallback
          
          if (!grid_to_replace || isPromoOnly) {
            this.hideLoadMoreButton();
            const noMoreMsg = document.getElementById('no-more-products');
            if (noMoreMsg) noMoreMsg.style.display = 'block';
            console.log("✅ No more products to load.");
            return;
          }
    
          // Otherwise: continue with rendering
          base.i++;
          base.renderProducts(responseText, url);
    
          dispatchCustomEvent('pagination:page-changed', {
            url: url
          });
        });
    }
    renderProducts(html, url) {
      let base = this,
          grid_to_replace = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
    
      if (!grid_to_replace) {
        if (base.observer) {
          base.observer.unobserve(base);
        }
        base.removeAttribute('loading');
        if (base.button) {
          base.button.classList.add('visually-hidden');
        }
        return;
      }
    
      let products = grid_to_replace.querySelectorAll('.column');
      let validProducts = [];

      // Check if there are any real (non-promo) products in the fetched page
      let hasValidProduct = false;
      products.forEach(item => {
        if (!item.classList.contains('promotion-column')) {
          hasValidProduct = true;
        }
      });
      
      if (!hasValidProduct) {
        base.hideLoadMoreButton();
        const noMoreMsg = document.getElementById('no-more-products');
        if (noMoreMsg) noMoreMsg.style.display = 'block';
        console.log("No more products to load.");
        return;
      }

      for (let i = 0; i < products.length; i++) {
        const product = products[i];
      
         // ✅ Remove promo blocks only on collection pages after page 1
        if (window.isCollectionPage && this.i > 2 && product.classList.contains('promotion-column')) {
          product.remove();
          continue;
        }
      
        validProducts.push(product);
        this.grid.appendChild(product);
      
        product.querySelectorAll('.lazyload').forEach((image) => {
          lazySizes.loader.unveil(image);
        });
      }

      // ✅ Check total product count including newly rendered ones
      const totalRendered = this.grid.querySelectorAll('.column:not(.promotion-column)').length;
      const productsPerPage = window.productsPerPage || 18;
      const totalAvailable = window.totalAvailableProducts || 53;
      
      if (totalRendered >= totalAvailable) {
        this.hideLoadMoreButton();
      
        // ✅ Show user-facing message on the page
        let noMoreMsg = document.getElementById('no-more-products');
        if (noMoreMsg) {
          noMoreMsg.style.display = 'block';
        } else {
          // Fallback: inject one if missing
          noMoreMsg = document.createElement('div');
          noMoreMsg.id = 'no-more-products';
          noMoreMsg.className = 'no-more-message';
          noMoreMsg.innerText = 'No more products to load.';
          this.button?.parentElement?.appendChild(noMoreMsg);
        }
      
        console.log("✅ No more products to load — shown on page.");
      }

      // ✅ Add .odd-product to 14th product if exists only on collection pages after page 1
      if (window.isCollectionPage && validProducts.length >= 14) {
        validProducts[13].classList.add('odd-product');
      }
      
      // ✅ Remove .odd-product from 16–18 if they exist only on collection pages after page 1
      if (window.isCollectionPage) {
        [15, 16, 17].forEach((index) => {
          if (validProducts[index]) {
            validProducts[index].classList.remove('odd-product');
          }
        });
      }

    
      if (this.animations_enabled) {
        gsap.set(products, { opacity: 0, y: 30 });
        gsap.to(products, {
          duration: 0.5,
          y: 0,
          opacity: 1,
          stagger: 0.05,
          onComplete: function () {
            base.removeAttribute('loading');
          }
        });
      } else {
        base.removeAttribute('loading');
      }
    
      // Color swatch hover callbacks
      document.querySelectorAll('.product-card').forEach(function(productCard) {
        productCard.querySelectorAll('.color_swatch li').forEach(function(item) {
          item.addEventListener('mouseover', function() {
            const imageUrl = item.querySelector('span').getAttribute('data-image-url');
            const mainImage = productCard.querySelector('.product-primary-image');
            mainImage.setAttribute('src', imageUrl);
            mainImage.setAttribute('srcset', imageUrl);
          });
    
          item.addEventListener('mouseout', function() {
            const masterUrl = productCard.querySelector('div.active_picker').getAttribute('data-image-url');
            const mainImage = productCard.querySelector('.product-primary-image');
            mainImage.setAttribute('src', masterUrl);
            mainImage.setAttribute('srcset', masterUrl);
          });
        });
      });
    }

  // Added by ocs to hide button function
    hideLoadMoreButton() {
      if (this.button) {
        this.button.classList.add("visually-hidden");
      }
    }
    // End by ocs to hide button function
  }
  customElements.define('pagination-theme', Pagination);
}